<template>
	<div class="wrapper">
		<side-bar>

			<sidebar-link to="/dashboard">
				<md-icon>card_giftcard</md-icon>
				<p>កញ្ចប់ឥវ៉ាន់របស់ខ្ញុំ</p>
			</sidebar-link>
			<sidebar-link to="/transactions">
				<md-icon>paid</md-icon>
				<p>ការទូទាត់ប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/settings">
				<md-icon>account_circle</md-icon>
				<p>កំណត់គណនី</p>
			</sidebar-link>
			<sidebar-link to="/logout">
				<md-icon>logout</md-icon>
				<p>ចាកចេញ</p>
			</sidebar-link>
		</side-bar>

		<div class="main-panel">
			<top-navbar></top-navbar>

			<dashboard-content style="margin-top: 40px">

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue